<div class="flex flex-column">
  <div class="text-sm text-700 font-light pb-1">{{label}}</div>
  <div class="flex w-full range-height border-round border-1 surface-border">
    <div *ngIf="minLimit" class="w-1 range-height bg-red-400"></div>
    <div *ngIf="min" class="w-2 range-height bg-orange-400"></div>
    <div class="w-6 range-height bg-green-400"></div>
    <div *ngIf="max" class="w-2 range-height bg-orange-400"></div>
    <div *ngIf="maxLimit" class="w-1 range-height bg-red-400"></div>
  </div>
  <div class="flex w-full text-xs">
    <div *ngIf="minLimit" class="w-1 flex justify-content-end"><span class="range-label-min">{{minLimit}}</span></div>
    <div *ngIf="min" class="w-2 flex justify-content-end"><span class="range-label-min">{{min}}</span></div>
    <div class="w-6"></div>
    <div *ngIf="max" class="w-2 flex justify-content-start"><span class="range-label-max">{{max}}</span></div>
    <div *ngIf="maxLimit" class="w-1 flex justify-content-start"><span class="range-label-max">{{maxLimit}}</span></div>
  </div>
</div>
